// extracted by mini-css-extract-plugin
export default {"contacts-section":"ContactsSection_contacts-section__+B0Rg","icon":"ContactsSection_icon__U1A1Z"};